import request from '@/lib/request'

export const UserRefundApplyAuditStatus = {
  NONE: 'NONE',
  APPLIED: 'APPLIED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
}
/***
 * 创建订单
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function createOrder(params = {}) {
  return request.post(`/api/v1/rental/order/create-order`, params);
}

/***
 * 查询订单列表
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function queryOrderList(params = {}) {
  return request.get('/api/v1/rental/order/list', params);
}

/***
 * 获取订单可填紧急联系人个数
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function getContactCount(params = {}) {
  return request.get('/api/v1/rental/emergency-contact/contactCount');
}

/**
 * 查询当前账号已保存的紧急联系人。
 * Android 下单页只从联系人库选择 id，不在 create-order 中提交用户输入快照。
 */
export function queryContactList(params = {}) {
  return request.get('/api/v1/rental/contact/list', params);
}

/** 新增联系人，接口保持后端批量请求契约。 */
export function addContact(contact = {}) {
  return request.post('/api/v1/rental/contact/', {
    contacts: [{
      name: contact.name || '',
      mobile: contact.mobile || '',
      relationship: contact.relationship || ''
    }]
  });
}

/** 更新联系人。 */
export function updateContact(contactId, contact = {}) {
  return request.put(`/api/v1/rental/contact/${contactId}`, {
    name: contact.name || '',
    mobile: contact.mobile || '',
    relationship: contact.relationship || ''
  });
}

/** 删除联系人。 */
export function deleteContact(contactId) {
  return request.delete(`/api/v1/rental/contact/${contactId}`);
}

/***
 * 查询订单详情
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function queryOrderDetail(params = {}) {
  return request.get(`/api/v1/rental/order/${params.orderId}`);
}

/***
 * 取消订单
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function cancelOrder(params = {}) {
  return request.post(`/api/v1/rental/order/${params.orderId}/cancel-order`, {
    reason: params.reason || '',
    refundType: params.refundType || '',
    refundBankId: params.refundBankId || '',
    refundBankName: params.refundBankName || '',
    accountNo: params.accountNo || '',
    accountName: params.accountName || ''
  });
}

/***
 * 撤回取消申请
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function withdrawCancelRefund(params = {}) {
  return request.post(`/api/v1/rental/order/${params.orderId}/cancel-refund`);
}

/***
 * 物流信息
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function queryExpressByOrderId(params = {}) {
  return request.get(`/api/v1/rental/order/${params.orderId}/express`);
}

/***
 * 还款预览，返回逾期总金额，及待还款订单预览信息
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function queryRepayInfoPreview(params = {}) {
  return request.get(`/api/v1/rental/repay/overview`, params);
}

/**
 * Android My Bills 使用的单期账单分页接口。
 * 列表状态、应付金额和到期日直接使用 records，不再由 overview 订单摘要拼装。
 */
export function queryRepayList(params = {}) {
  return request.get(`/api/v1/rental/repay/list`, {
    pageNum: Math.max(Number(params.pageNum) || 1, 1),
    pageSize: Math.max(Number(params.pageSize) || 20, 1)
  });
}

/***
 * 查询订单还款计划
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function queryRepayPlan(params = {}) {
  return request.get(`/api/v1/rental/order/${params.orderId}/repay-plan`);
}



/***
 * 还款申请，返回还款订单id、支付地址、订单金额
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function repay(params = {}) {
  return request.post(`/api/v1/rental/repay`, params);
}

/***
 * 查询进行中的还款订单
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function queryRepayOrder(params = {}) {
  return request.get(`/api/v1/rental/order/${params.orderId}/repay-order`);
}
